/** Working-memory tray storage (spec §9.19): `core.settings.tray`, a LoroList of `{id, text, at}`. */
import { LoroList, type LoroDoc } from "loro-crdt";
import { ulid } from "ulid";
import { commitMessage } from "../core/actor";
import { C } from "../core/schema";

export interface TrayItem {
  id: string;
  text: string;
  at: string;
  /** where it was captured, when not typed here (I0): phone, telegram, email, voice, button, script, api */
  source?: string;
}

export const STALE_MS = 7 * 86_400_000;

function trayList(doc: LoroDoc): LoroList<TrayItem> {
  const settings = doc.getMap(C.settings);
  const cur = settings.get("tray") as unknown;
  // the v1 default is a plain `[]` value, which also has `push`; only a real container counts
  if (cur instanceof LoroList) return cur as LoroList<TrayItem>;
  return settings.setContainer("tray", new LoroList()) as unknown as LoroList<TrayItem>;
}

export function readTray(doc: LoroDoc): TrayItem[] {
  const v = (doc.getMap(C.settings).toJSON() as { tray?: TrayItem[] }).tray;
  return Array.isArray(v) ? v.filter((x) => x && typeof x === "object" && x.text) : [];
}

export function trayAdd(doc: LoroDoc, text: string, source?: string): void {
  trayList(doc).push({ id: ulid(), text, at: new Date().toISOString(), ...(source ? { source } : {}) });
  doc.commit({ message: commitMessage({ op: "trayAdd" }) });
}

export function trayRemove(doc: LoroDoc, id: string): void {
  const list = trayList(doc);
  const i = (list.toArray() as TrayItem[]).findIndex((x) => x.id === id);
  if (i < 0) return;
  list.delete(i, 1);
  doc.commit({ message: commitMessage({ op: "trayRemove" }) });
}
